module.exports = __webpack_public_path__ + "static/img/sbgl.fd22e08.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/sbgl.jpg
// module id = DGqT
// module chunks = 1